import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type UpdatePartnerNotesInput = {
  id: string;
  notes: string;
};

// PATCH /api/partners/:id/notes — sub-path for the notes-only textarea so
// the SPA doesn't need to send the full edit shape just to save a note.
export function useUpdatePartnerNotes() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, UpdatePartnerNotesInput>({
    mutationFn: ({ id, notes }) =>
      apiFetch<{ ok: true }>(`/partners/${id}/notes`, {
        method: "PATCH",
        body: JSON.stringify({ notes }),
      }),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(id) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to save notes");
    },
  });
}
